export default __webpack_public_path__ + "static/media/dark-legacies-raider-battle.6e867870.png";